export type CabinClassType = "economy" | "business" | "first" | "premium"

export type CabinClass = {
  type: CabinClassType
  allowMixed: boolean
}

export const CABIN_CLASS = {
  // @ts-expect-error: Flow to TS migration.
  economy: __("form_search.cabin_class.economy"),
  // @ts-expect-error: Flow to TS migration.
  premium: __("form_search.cabin_class.premium"),
  // @ts-expect-error: Flow to TS migration.
  business: __("form_search.cabin_class.business"),
  // @ts-expect-error: Flow to TS migration.
  first: __("form_search.cabin_class.first"),
} as const

export const DEFAULT_CABIN_CLASS_TYPE: CabinClassType = "economy"
export const DEFAULT_CABIN_CLASS: CabinClass = {
  type: DEFAULT_CABIN_CLASS_TYPE,
  allowMixed: true,
}

export const cabinClassToQuery = (cabinClass: CabinClass) =>
  `${cabinClass.type}-${cabinClass.allowMixed.toString()}`
